"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _BalanceDefinition = _interopRequireDefault(require("./BalanceDefinition"));
var _Tag = _interopRequireDefault(require("./Tag"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Balance model module.
 * @module model/Balance
 * @version 3.0
 */
var Balance = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Balance</code>.
   * @alias module:model/Balance
   */
  function Balance() {
    _classCallCheck(this, Balance);
    Balance.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Balance, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>Balance</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Balance} obj Optional instance to populate.
     * @return {module:model/Balance} The populated <code>Balance</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Balance();
        if (data.hasOwnProperty('balanceId')) {
          obj['balanceId'] = _ApiClient["default"].convertToType(data['balanceId'], 'Number');
        }
        if (data.hasOwnProperty('balanceLegacyId')) {
          obj['balanceLegacyId'] = _ApiClient["default"].convertToType(data['balanceLegacyId'], 'String');
        }
        if (data.hasOwnProperty('balanceReferenceId')) {
          obj['balanceReferenceId'] = _ApiClient["default"].convertToType(data['balanceReferenceId'], 'String');
        }
        if (data.hasOwnProperty('balanceType')) {
          obj['balanceType'] = _ApiClient["default"].convertToType(data['balanceType'], 'String');
        }
        if (data.hasOwnProperty('quantity')) {
          obj['quantity'] = _ApiClient["default"].convertToType(data['quantity'], 'Number');
        }
        if (data.hasOwnProperty('refreshDateTime')) {
          obj['refreshDateTime'] = _ApiClient["default"].convertToType(data['refreshDateTime'], 'Date');
        }
        if (data.hasOwnProperty('expiryDateTime')) {
          obj['expiryDateTime'] = _ApiClient["default"].convertToType(data['expiryDateTime'], 'Date');
        }
        if (data.hasOwnProperty('units')) {
          obj['units'] = _ApiClient["default"].convertToType(data['units'], 'String');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('startingQuantity')) {
          obj['startingQuantity'] = _ApiClient["default"].convertToType(data['startingQuantity'], 'Number');
        }
        if (data.hasOwnProperty('balanceDisplayName')) {
          obj['balanceDisplayName'] = _ApiClient["default"].convertToType(data['balanceDisplayName'], 'String');
        }
        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient["default"].convertToType(data['category'], 'String');
        }
        if (data.hasOwnProperty('rank')) {
          obj['rank'] = _ApiClient["default"].convertToType(data['rank'], 'Number');
        }
        if (data.hasOwnProperty('balanceDefinition')) {
          obj['balanceDefinition'] = _BalanceDefinition["default"].constructFromObject(data['balanceDefinition']);
        }
        if (data.hasOwnProperty('tags')) {
          obj['tags'] = _ApiClient["default"].convertToType(data['tags'], [_Tag["default"]]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Balance</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Balance</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['balanceLegacyId'] && !(typeof data['balanceLegacyId'] === 'string' || data['balanceLegacyId'] instanceof String)) {
        throw new Error("Expected the field `balanceLegacyId` to be a primitive type in the JSON string but got " + data['balanceLegacyId']);
      }
      // ensure the json data is a string
      if (data['balanceReferenceId'] && !(typeof data['balanceReferenceId'] === 'string' || data['balanceReferenceId'] instanceof String)) {
        throw new Error("Expected the field `balanceReferenceId` to be a primitive type in the JSON string but got " + data['balanceReferenceId']);
      }
      // ensure the json data is a string
      if (data['balanceType'] && !(typeof data['balanceType'] === 'string' || data['balanceType'] instanceof String)) {
        throw new Error("Expected the field `balanceType` to be a primitive type in the JSON string but got " + data['balanceType']);
      }
      // ensure the json data is a string
      if (data['units'] && !(typeof data['units'] === 'string' || data['units'] instanceof String)) {
        throw new Error("Expected the field `units` to be a primitive type in the JSON string but got " + data['units']);
      }
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['balanceDisplayName'] && !(typeof data['balanceDisplayName'] === 'string' || data['balanceDisplayName'] instanceof String)) {
        throw new Error("Expected the field `balanceDisplayName` to be a primitive type in the JSON string but got " + data['balanceDisplayName']);
      }
      // ensure the json data is a string
      if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
        throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
      }
      // validate the optional field `balanceDefinition`
      if (data['balanceDefinition']) {
        // data not null
        _BalanceDefinition["default"].validateJSON(data['balanceDefinition']);
      }
      if (data['tags']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['tags'])) {
          throw new Error("Expected the field `tags` to be an array in the JSON data but got " + data['tags']);
        }
        // validate the optional field `tags` (array)
        var _iterator = _createForOfIteratorHelper(data['tags']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _Tag["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} balanceId
 */
Balance.prototype['balanceId'] = undefined;

/**
 * @member {String} balanceLegacyId
 */
Balance.prototype['balanceLegacyId'] = undefined;

/**
 * @member {String} balanceReferenceId
 */
Balance.prototype['balanceReferenceId'] = undefined;

/**
 * @member {String} balanceType
 */
Balance.prototype['balanceType'] = undefined;

/**
 * @member {Number} quantity
 */
Balance.prototype['quantity'] = undefined;

/**
 * @member {Date} refreshDateTime
 */
Balance.prototype['refreshDateTime'] = undefined;

/**
 * @member {Date} expiryDateTime
 */
Balance.prototype['expiryDateTime'] = undefined;

/**
 * @member {String} units
 */
Balance.prototype['units'] = undefined;

/**
 * @member {String} currency
 */
Balance.prototype['currency'] = undefined;

/**
 * @member {Number} startingQuantity
 */
Balance.prototype['startingQuantity'] = undefined;

/**
 * @member {String} balanceDisplayName
 */
Balance.prototype['balanceDisplayName'] = undefined;

/**
 * @member {String} category
 */
Balance.prototype['category'] = undefined;

/**
 * @member {Number} rank
 */
Balance.prototype['rank'] = undefined;

/**
 * @member {module:model/BalanceDefinition} balanceDefinition
 */
Balance.prototype['balanceDefinition'] = undefined;

/**
 * @member {Array.<module:model/Tag>} tags
 */
Balance.prototype['tags'] = undefined;
var _default = exports["default"] = Balance;